import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import areaOfInterest from './components/AreaOfInterest';
import PartnerReports from './components/PartnerReports';
import drawerItem from '../components/DrawerItem';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Collapse from '@material-ui/core/Collapse';
import i18n from 'react-intl-universal';
import { Link } from 'react-router-dom';
import AreaIcon from '@material-ui/icons/Dashboard';
import LogoutIcon from '@material-ui/icons/LockOpen';
import PartnerReportsIcon from '../components/SvgIcons/coin';
import HelpIcon from '@material-ui/icons/Help';
import HomeIcon from '@material-ui/icons/Home';
import Icon from '@material-ui/core/Icon';
import DrawerOpenIcon from '@material-ui/icons/ArrowRight';
import DrawerCloseIcon from '@material-ui/icons/ArrowLeft';
import BackIcon from '@material-ui/icons/KeyboardBackspace';
import {
  INIT_PARTNER_REPORTS_FILTER_STATE,
  fetch_country_details,
  fetch_cb_cluster_details_by_id,
  fetch_cb_area_details_by_id,
  fetch_cb_thana_details_by_id,
  change_filtering_state
} from './actions';
// import * as LeftSidebarActionConstants from './actions';
import { logout } from '../../../actions';
import {} from '../../reducers';
import {
  getAllCbClusters,
  getAllCbAreas,
  getAllCbThanas,
  getFilteringState
} from './reducers';

import logo from '../../../../assets/images/logo.svg';
import styles from '../styles';

const LeftSidebarContent = ({ ...props }) => {
  const [open, setOpen] = useState(true);
  const [expand, setExapnd] = useState(true);

  const [anchorEl, setAnchorEl] = useState(null);
  const [hoverItemText, setHoverItemText] = useState('');
  const [popperHoverOpen, setPopperHoverOpen] = useState(false);
  const { classes } = props;

  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedTerritory, setSelectedTerritory] = useState(null);
  const [PartnerReportsExpand, setPartnerReportsExpand] = useState(true);
  const [areaOfInterestExpand, setAreaOfInterestExpand] = useState(false);

  useEffect(() => {
    if (selectedRegion) {
      props.fetch_cb_cluster_details_by_id(
        selectedRegion,
        props.dateRange,
        props.filterType
      );
    }
  }, [selectedRegion]);

  useEffect(() => {
    if (selectedArea) {
      props.fetch_cb_area_details_by_id(
        selectedArea,
        props.dateRange,
        props.filterType
      );
    }
  }, [selectedArea]);

  useEffect(() => {
    if (selectedTerritory) {
      props.fetch_cb_thana_details_by_id(
        selectedTerritory,
        props.dateRange,
        props.filterType
      );
    }
  }, [selectedTerritory]);

  useEffect(() => {
    if (selectedArea) {
      setSelectedArea(null);
    }
  }, [props.allAreas]);

  useEffect(() => {
    if (selectedTerritory) {
      setSelectedTerritory(null);
    }
  }, [props.allTerritories]);

  useEffect(() => {
    // fetch country details on initial left sidebar
    props.fetch_country_details(props.dateRange, props.filterType);
  }, []);

  const selectedAreaAction = id => {
    setSelectedArea(id);
  };

  const selectedRegionAction = id => {
    setSelectedRegion(id);
  };
  const selectedTerritoryAction = id => {
    setSelectedTerritory(id);
  };

  const handleItemClick = () => {
    if (!open) {
      setOpen(true);
      setPopperHoverOpen(false);
    }
  };

  const handlePartnerReportsClick = () => {
    handleItemClick();
    if (!PartnerReportsExpand) {
      props.change_filtering_state(INIT_PARTNER_REPORTS_FILTER_STATE);
      setPartnerReportsExpand(true);
    }
  };

  const handleAreaOfInterestClick = () => {
    handleItemClick();
    if (open) {
      setAreaOfInterestExpand(!areaOfInterestExpand);
    }
  };

  const toggleExpand = () => {
    setExapnd(!expand);
    setAreaOfInterestExpand(false);
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleItemHover = (event, title) => {
    const { currentTarget } = event;
    setAnchorEl(currentTarget);
    setPopperHoverOpen(true);
    setHoverItemText(title);
  };

  const setPartnerReportsViewUpdate = value =>
    props.change_filtering_state({
      partner_update: value,
      partner_transaction: false
    });

  const setPartnerReportsViewTransaction = value =>
    props.change_filtering_state({
      partner_update: false,
      partner_transaction: value
    });

  const onChangePartnerReports = (itemState, value) => {
    if (
      (!value &&
        props.filteringState.partner_update &&
        props.filteringState.partner_transaction) ||
      value
    ) {
      itemState(value);
    }
  };

  return (
    <div
      className={classNames({
        [classes.drawerWrapperOpen]: open,
        [classes.drawerWrapperClose]: !open
      })}
    >
      <div>
        <Paper
          className={classNames({
            [classes.topBarOpen]: open,
            [classes.topBarClose]: !open
          })}
        >
          <Link to="/">
            <img
              className={open ? classes.logoOpen : classes.logoClose}
              src={logo}
              alt={i18n.get('app.siteName')}
            />
          </Link>
        </Paper>
      </div>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <Drawer
          variant="permanent"
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open
          })}
          classes={{
            paper: classNames({
              [classes.drawerOpen]: { open },
              [classes.drawerClose]: !open
            })
          }}
          open={open}
        >
          <div className={classes.toolbar} />
          <Popper
            open={popperHoverOpen}
            anchorEl={anchorEl}
            placement={'right'}
            transition
            className={classes.popper}
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <Typography className={classes.typography}>
                    {hoverItemText}
                  </Typography>
                </Paper>
              </Fade>
            )}
          </Popper>
          <div className={classes.drawerContainer}>
            <List>
              {drawerItem({
                key: 'areaOfInterest',
                i18nTitle: 'app.dashboard.sidebar.areaOfInterest.title',
                Icon: AreaIcon,
                showExpandIcon: true,
                handleItemClick: handleAreaOfInterestClick,
                expand: areaOfInterestExpand,
                open,
                setPopperHoverOpen,
                handleItemHover,
                classes
              })}
              <Collapse
                in={open && areaOfInterestExpand}
                timeout="auto"
                unmountOnExit
              >
                {areaOfInterest({
                  classes,
                  regions: props.allRegions,
                  actionOnSelectedRegion: selectedRegionAction,
                  areas: props.allAreas,
                  actionOnSelectedArea: selectedAreaAction,
                  territories: props.allTerritories,
                  actionOnSelectedTerritory: selectedTerritoryAction,
                  selectedRegion,
                  selectedArea,
                  selectedTerritory
                })}
              </Collapse>
            </List>
            <Divider />
            <List>
              {drawerItem({
                key: 'PartnerReports',
                i18nTitle: 'app.dashboard.sidebar.PartnerReports.title',
                Icon: PartnerReportsIcon,
                showExpandIcon: true,
                handleItemClick: handlePartnerReportsClick,
                expand: PartnerReportsExpand,
                open,
                setPopperHoverOpen,
                handleItemHover,
                classes
              })}
              <Collapse
                in={open && PartnerReportsExpand}
                timeout="auto"
                unmountOnExit
              >
                {PartnerReports({
                  classes,
                  filteringStatePartnerUpdate:
                    props.filteringState.partner_update,
                  setPartnerReportsViewUpdate,
                  filteringStatePartnerTransaction:
                    props.filteringState.partner_transaction,
                  setPartnerReportsViewTransaction,
                  onChangePartnerReports
                })}
              </Collapse>
            </List>
            <Divider />
            <List>
              {drawerItem({
                key: 'topicWiseFiltering',
                i18nTitle: 'app.dashboard.sidebar.logout.title',
                Icon: LogoutIcon,
                handleItemClick: props.logout,
                open,
                setPopperHoverOpen,
                handleItemHover,
                classes
              })}
            </List>
          </div>
        </Drawer>
      </Collapse>
      <div>
        <Paper
          className={classNames({
            [classes.drawerExpandMoreIcon]: !expand,
            [classes.drawerExpandLessIcon]: expand,
            [classes.drawerClose]: !open
          })}
        >
          <ListItem>
            <IconButton onClick={toggleExpand}>
              {expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
            {open && <ListItemText primary={expand ? 'Hide' : 'See More'} />}
          </ListItem>
        </Paper>
      </div>
      <Paper className={classes.toggleDrawerState}>
        <div
          button="true"
          className={classes.toggleDrawerIcon}
          onClick={toggleDrawer}
        >
          {!open ? <DrawerOpenIcon /> : <DrawerCloseIcon />}
        </div>
      </Paper>
      <Paper
        className={classNames(classes.mapActions, {
          [classes.mapActionsDrawerClose]: !open
        })}
      >
        <HelpIcon
          style={{ cursor: 'hand' }}
          onClick={props.onHelpButtonClick}
        />
        <Divider className={classes.verticalDivider} />
        <Icon
          aria-label="cb"
          onClick={props.onRatButtonClick}
          style={{ width: '1.5em', cursor: 'hand' }}
        >
          <Typography variant="subtitle1" align="center" display="block">
            S&D
          </Typography>
        </Icon>
        <Divider className={classes.verticalDivider} />
        <HomeIcon
          style={{ cursor: 'hand' }}
          onClick={props.onHomeButtonClick}
        />
        <Divider className={classes.verticalDivider} />
        <BackIcon
          style={{ cursor: 'hand' }}
          onClick={props.onBackButtonClick}
        />
      </Paper>
    </div>
  );
};

const mapStateToProps = state => ({
  allRegions: getAllCbClusters(state),
  allAreas: getAllCbAreas(state),
  allTerritories: getAllCbThanas(state),
  filteringState: getFilteringState(state)
});

const mapDispatchToProps = {
  fetch_country_details,
  fetch_cb_cluster_details_by_id,
  fetch_cb_area_details_by_id,
  fetch_cb_thana_details_by_id,
  change_filtering_state,
  logout
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LeftSidebarContent));
